var parent = require('../../es/promise');
require('../../modules/esnext.aggregate-error');
// TODO: Remove from `core-js@4`
require('../../modules/esnext.promise.all-settled');
require('../../modules/esnext.promise.try');
require('../../modules/esnext.promise.any');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/features/promise/index.js
// module id = 997
// module chunks = 1